import React, { useEffect, useState } from "react";
import {
  GetClientService,
  EditClientPanle,
  Get_Broker_Name,
  GetAllSubadminName,
} from "../../CommonAPI/Admin";
import ReusableModal from "../../../ExtraComponent/ReusableModal";
import FullDataTable from "../../../ExtraComponent/CommanDataTable";
import { useNavigate } from "react-router-dom";
import { SquarePen } from "lucide-react";
import { useFormik } from "formik";
import AddForm from "../../../ExtraComponent/FormData";
import Swal from "sweetalert2";
import { Get_All_Plans } from "../../CommonAPI/User";
import NoDataFound from "../../../ExtraComponent/NoDataFound";
import Content from "../../../ExtraComponent/Content";
import Loader from "../../../ExtraComponent/Loader";

const Clientservice = () => {
  const navigate = useNavigate();
  const adminPermission = localStorage.getItem("adminPermission");
  const [clientService, setClientService] = useState({
    loading: true,
    data: [],
  });
  const [clientServiceFiltered, setClientServiceFiltered] = useState({
    loading: true,
    data: [],
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [brokerRecordData, setBrokerRecordData] = useState([]);
  const [showBrokerModal, setShowBrokerModal] = useState(false);
  const permissionArray = [];
  const [subadmins, setSubadmins] = useState([]); // State to hold subadmin data
  const [selectedSubadmin, setSelectedSubadmin] = useState("All"); // State for selected subadmin filter
  const [LiveStatus, setLiveStatus] = useState("All");
  const [BrokerName, setBrokerName] = useState("All");
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedClientForPlan, setSelectedClientForPlan] = useState(null);
  const [allPlans, setAllPlans] = useState({
    LivePlanName: [],
    DemoPlanName: [],
    data: [],
    SOPDEMO: [],
    SOPLive: [],
    ChartDEMO: [],
    ChartLive: [],
  });
  if (adminPermission) {
    adminPermission?.includes("Option Chain") &&
      permissionArray.push({ label: "Option Chain", value: "Option Chain" });
    adminPermission?.includes("Golden Strategy") &&
      permissionArray.push({
        label: "Golden Strategy",
        value: "Golden Strategy",
      });
  }
  const [selectedBroker, setSelectedBroker] = useState("");

  useEffect(() => {
    fetchBrokerName();
    GetAllPlansData();
    getAllSubadmin();
  }, []);

  useEffect(() => {
    fetchClientService();
  }, [LiveStatus, selectedSubadmin, BrokerName]);

  useEffect(() => {
    if (searchInput && clientService.data) {
      const filteredData = clientService.data.filter((item) => {
        const searchInputMatch =
          searchInput === "" ||
          item.Username.toLowerCase().includes(searchInput.toLowerCase()) ||
          item.Mobile_No.toLowerCase().includes(searchInput.toLowerCase()) ||
          item.EmailId.toLowerCase().includes(searchInput.toLowerCase()) ||
          item.BrokerName.toLowerCase().includes(searchInput.toLowerCase());
        return searchInputMatch;
      });
      setClientServiceFiltered({
        loading: false,
        data: filteredData,
      });
    }
  }, [searchInput]);

  useEffect(() => {
    if (showModal) {
      formik.setFieldValue(
        "Broker",
        selectedIndex.BrokerName == "DEMO" ? "" : selectedIndex.BrokerName
      );
      formik.setFieldValue("User", selectedIndex.Username);
    }
  }, [showModal]);

  const fetchBrokerName = async () => {
    try {
      const response = await Get_Broker_Name();
      if (response.Status) {
        const brokerList = response.brokers.filter(
          (item) => item.BrokerName !== "DEMO"
        );
        setBrokers(brokerList);
      } else {
        setBrokers([]);
      }
    } catch (error) {
      console.log("Error in fetching brokers", error);
    }
  };

  const fetchClientService = async () => {
    try {
      const response = await GetClientService();
      if (response.Status) {
        let filteredData = response.Data;

        if (LiveStatus !== "All") {
          if (LiveStatus === "Free") {
            filteredData = filteredData.filter(
              (client) => client.BrokerName === "DEMO"
            );
          } else if (LiveStatus === "Paid") {
            filteredData = filteredData.filter(
              (client) => client.BrokerName !== "DEMO"
            );
          }
        }

        if (selectedSubadmin !== "All") {
          filteredData = filteredData.filter(
            (client) =>
              client.SubAdmin ===
              (selectedSubadmin === "Admins" ? "" : selectedSubadmin)
          );
        }

        if (BrokerName != "All") {
          filteredData = filteredData.filter(
            (client) => client.BrokerName === BrokerName
          );
        }

        setClientService({
          loading: false,
          data: filteredData,
        });
        setClientServiceFiltered({
          loading: false,
          data: filteredData,
        });
      } else {
        setClientService({ loading: false, data: [] });
        setClientServiceFiltered({ loading: false, data: [] });
      }
    } catch (error) {
      console.log("Error in fetching client services", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      User: "",
      Broker: "",
      GroupName: "",
      permissions: [],
    },
    validate: (values) => {
      const errors = {};

      if (!values.Broker && showModal) {
        errors.Broker = "Please Select the Broker";
      }

      return errors;
    },

    onSubmit: async (values) => {
      const req = {
        User: values.User,
        // GroupName: selectedOptions?.map((item) => item?.value || item),
        SubAdmin: "",
        Broker: values.Broker,
        Permission: formik.values.permissions || [], // Ensure permissions is always an array
      };

      try {
        const response = await EditClientPanle(req);
        if (response.Status) {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Updated",
            text: response.message,
            icon: "success",
            timer: 1500,
            timerProgressBar: true,
          });
          setTimeout(() => {
            setShowModal(false);
            formik.resetForm();
          }, 1500);
          fetchClientService();
        } else {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Error",
            text: response.message,
            icon: "error",
            timer: 1500,
            timerProgressBar: true,
          });
        }
      } catch (err) {
        console.log("Error in update client", err);
      }
    },
  });

  const fields = [
    {
      name: "Broker",
      label: "Broker",
      type: "select",
      options:
        brokers &&
        brokers.map((item) => ({
          label: item.BrokerName,
          value: item.BrokerName,
        })),
      showWhen: (values) => selectedIndex.BrokerName !== "DEMO",
      label_size: 12,
      col_size: 12,
    },
  ];

  const columns = [
    {
      name: "S.No",
      label: "S.No",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1,
      },
    },

    {
      name: "Username",
      label: "Username",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "Mobile_No",
      label: "Mobile Number",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    // {
    //   name: "EmailId",
    //   label: "Email ID",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value) => value || "-",
    //   },
    // },
    {
      name: "LiveTrading",
      label: "Live Trading",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "ActivePlan",
      label: "Plan Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          // Dropdown for plans (enabled, fixed width)
          const plans = Array.isArray(value) ? value : value ? [value] : [];
          return (
            <select
              style={{
                width: 160,
                minWidth: 160,
                maxWidth: 160,
                padding: "4px 8px",
                borderRadius: 4,
                background: "#fff",
                color: "#222",
                cursor: "pointer",
              }}
              defaultValue={plans[0] || ""}
              onClick={(e) => e.stopPropagation()} // Prevent row click
            >
              {plans.length > 0 ? (
                plans.map((plan, idx) => (
                  <option key={idx} value={plan}>
                    {plan}
                  </option>
                ))
              ) : (
                <option value="">-</option>
              )}
            </select>
          );
        },
      },
    },
    {
      name: "SubAdmin",
      label: "Created by",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) =>
          value == "" || value == null ? "Admin" : value,
      },
    },
    {
      name: "AssignPlan",
      label: "Assign Plan",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowData = clientService.data[tableMeta.rowIndex];
          const brokerName = rowData?.BrokerName;

          // If BrokerName is "DEMO", don't show the button
          // if (brokerName === "DEMO" || brokerName === "Demo") {
          //   return "-";
          // }

          return (
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => {
                setSelectedClientForPlan(rowData);
                setShowPlanModal(true);
                setSelectedBroker(rowData?.BrokerName || "DEMO");
              }}
              style={{ fontSize: "12px", padding: "4px 8px" }}
            >
              Assign Plan
            </button>
          );
        },
      },
    },
    {
      name: "Edit",
      label: "Edit",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const rowData = clientService.data[tableMeta.rowIndex];
          const brokerName = rowData?.BrokerName;
          if (brokerName === "DEMO" || brokerName === "Demo") {
            return "-";
          }

          return (
            <SquarePen
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShowModal(true);
                // Find the selected client by Username (index 1 = Username column)
                const selectedUser = clientServiceFiltered.data.find(
                  (client) => client.Username === tableMeta.rowData[1]
                );

                if (selectedUser) {
                  // Store selected client info if needed
                  setSelectedIndex(selectedUser);

                  // Prefill Formik values
                  formik.setFieldValue("User", selectedUser.Username);
                  formik.setFieldValue(
                    "Broker",
                    selectedUser.BrokerName === "DEMO"
                      ? ""
                      : selectedUser.BrokerName
                  );
                  formik.setFieldValue(
                    "permissions",
                    selectedUser.Permission || []
                  );
                } else {
                  console.warn(
                    "Client not found for username:",
                    tableMeta.rowData[3]
                  );
                }
              }}
            />
          );
        },
      },
    },

    {
      name: "BrokerName",
      label: "Broker Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },

    {
      name: "CreateDate",
      label: "Account Create Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "ServiceStartDate",
      label: "Service Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "ServiceEndDate",
      label: "Service End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "Total Service Count",
      label: "Total Service Count",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
  ];

  const getAllSubadmin = async () => {
    try {
      const response = await GetAllSubadminName();

      if (response && response.Status) {
        setSubadmins(response.Data); // 👈 direct array set
      } else {
        setSubadmins([]);
      }
    } catch (error) {
      console.error("Error fetching subadmin data:", error);
      setSubadmins([]);
    }
  };

  // Formik for Plan Assignment Modal
  const planFormik = useFormik({
    initialValues: {
      selectedPlans: [],
      amount: "",
    },
    validate: (values) => {
      const errors = {};

      return errors;
    },
    onSubmit: async (values) => {
      const req = {
        User: selectedClientForPlan?.Username,
        Broker: selectedBroker || selectedClientForPlan?.BrokerName,
        SubAdmin: "",
      };

      if (values.amount > 0) {
        req.Clientammount = values.amount;
      }

      if (values.selectedPlans.length > 0) {
        // remove existing plans from selectedPlans to avoid duplication
        const existingPlans = Array.isArray(selectedClientForPlan?.Planname)
          ? selectedClientForPlan.Planname
          : selectedClientForPlan?.Planname
          ? [selectedClientForPlan.Planname]
          : [];

        // Filter out existing plans from selectedPlans
        const newPlans = values.selectedPlans.filter(
          (plan) => !existingPlans.includes(plan)
        );
        req.SOPPlanname = newPlans?.length == 0 ? "" : newPlans[0];
      }

      try {
        const UpdateData = await EditClientPanle(req);

        if (UpdateData?.Status) {
          Swal.fire({
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Success",
            text: "Plan and amount updated successfully!",
            icon: "success",
            timer: 1500,
            timerProgressBar: true,
          });

          setTimeout(() => {
            setShowPlanModal(false);
            planFormik.resetForm();
            setSelectedClientForPlan(null);
          }, 1500);
          fetchClientService();
        }
      } catch (err) {
        console.log("Error in updating plan", err);
        Swal.fire({
          backdrop: "#121010ba",
          confirmButtonColor: "#1ccc8a",
          title: "Error",
          text: "Failed to update plan and amount",
          icon: "error",
        });
      }
    },
  });
  const GetAllPlansData = async () => {
    await Get_All_Plans()
      .then((response) => {
        if (response.Status) {
          const LivePlanName = [
            ...response.Admin.filter(
              (item) =>
                item.Planname !== "One Week Demo" &&
                item.Planname !== "Two Days Demo"
            ),
            ...response.Charting, // Charting array ko add kar diya
          ];

          const SOPPlans = LivePlanName.filter(
            (item) =>
              item.Planname !== "One Week Demo" &&
              item.Planname !== "Two Days Demo" &&
              item.ChartingSignal.length === 0
          );
          const ChartPlans = LivePlanName.filter(
            (item) =>
              item.Planname !== "One Week Demo" &&
              item.Planname !== "Two Days Demo" &&
              item.ChartingSignal.length !== 0
          );

          const DemoPlanName = response.Admin.filter(
            (item) =>
              item.Planname === "One Week Demo" ||
              item.Planname === "Two Days Demo"
          );

          const sopDemo = response.Admin.filter(
            (item) => item.PlanType === "Demo"
          );
          let sopLive = response.Admin.filter(
            (item) => item.PlanType === "Live"
          );
          sopLive = sopLive.map((plan) => {
            return {
              ...plan,
              price: plan.SOPPrice,
            };
          });

          const chartDemo = response.Charting.filter(
            (item) => item.PlanType === "Demo"
          );
          let chartLive = response.Charting.filter(
            (item) => item.PlanType === "Live"
          );
          chartLive = chartLive.map((plan) => {
            return {
              ...plan,
              price: plan.ChartPerMonth,
            };
          });

          const OverallDataDemo = response.OverallData.filter(
            (item) => item.PlanType === "Demo"
          );
          let OverallDataLive = response.OverallData.filter(
            (item) => item.PlanType === "Live"
          );
          OverallDataLive = OverallDataLive.map((plan) => {
            return {
              ...plan,
              price: plan.OverallPrice,
            };
          });

          setAllPlans({
            demo: [...sopDemo, ...chartDemo, ...OverallDataDemo],
            live: [...sopLive, ...chartLive, ...OverallDataLive],
          });
        } else {
          setAllPlans({ DemoPlanName: [], LivePlanName: [], data: [] });
        }
      })
      .catch((err) => {
        console.log("Error in fetching the plans", err);
      });
  };

  return (
    <>
      <Content
        Page_title={"Clients"}
        button_status={true}
        backbutton_status={true}
        route={"/admin/adduser"}
        button_title={"Create Account"}
      >
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item active " aria-current="page">
              Clients
            </li>
          </ol>
        </nav>
        {clientServiceFiltered.loading ? (
          <Loader />
        ) : (
          <>
            <div className="d-flex justify-content-between card-bg-color mb-3 align-items-end">
              <div className=" col-lg-2">
                <label className="form-label card-text-Color">Search</label>
                <input
                  type="text"
                  className=" form-control rounded "
                  placeholder="Search..."
                  onChange={(e) => setSearchInput(e.target.value)}
                  value={searchInput}
                />
              </div>
              <div className=" col-lg-2">
                <label className="form-label card-text-Color">Created by</label>
                <select
                  className="form-select"
                  onChange={(e) => setSelectedSubadmin(e.target.value)}
                  value={selectedSubadmin}
                >
                  <option value="All">All</option>
                  <option value="Admins">Admins</option>

                  {subadmins &&
                    subadmins?.map((subadmin, index) => (
                      <option key={index} value={subadmin}>
                        {subadmin}
                      </option>
                    ))}
                </select>
              </div>
              <div className=" col-lg-2">
                <label className="form-label card-text-Color">
                  Client Type
                </label>
                <select
                  className="form-select"
                  onChange={(e) => setLiveStatus(e.target.value)}
                  value={LiveStatus}
                >
                  <option value="All">All</option>
                  <option value="Paid">Paid</option>
                  <option value="Free">Free</option>
                </select>
              </div>
              <div className=" col-lg-2">
                <label className="form-label card-text-Color">
                  Broker Name
                </label>
                <select
                  className="form-select"
                  onChange={(e) => setBrokerName(e.target.value)}
                  value={BrokerName}
                >
                  <option value="All">All</option>
                  <option value="DEMO">DEMO</option>

                  {brokers &&
                    brokers.map((item, index) => (
                      <option key={index} value={item.BrokerName}>
                        {item.BrokerName}
                      </option>
                    ))}
                </select>
              </div>

              <div className=" col-lg-3">
                <button
                  className="btn btn-secondary me-2"
                  onClick={() => {
                    setLiveStatus("All");
                    setSelectedSubadmin("All");
                    setBrokerName("All");
                    setSearchInput("");
                  }}
                >
                  Reset
                </button>
                <button
                  className="addbtn btn "
                  onClick={() => navigate("/admin/adduser")}
                >
                  Create Account
                </button>
              </div>
            </div>
            {clientServiceFiltered.data &&
            clientServiceFiltered.data.length > 0 ? (
              <FullDataTable
                columns={columns}
                data={clientServiceFiltered.data}
                checkBox={false}
              />
            ) : (
              <NoDataFound />
            )}
          </>
        )}

        {/* Edit Client */}
        <ReusableModal
          show={showModal}
          onClose={() => {
            setShowModal(false);
            formik.resetForm();
          }}
          title={`Edit Client: ${selectedIndex?.Username}`}
          size="md"
          body={
            <AddForm
              fields={fields.filter(
                (field) => !field.showWhen || field.showWhen(formik.values)
              )}
              btn_name="Update"
              formik={formik}
              btn_name1_route="/admin/clientservice"
              additional_field={
                <div className="mt-2">
                  {permissionArray.length > 0 && (
                    <div className="col-lg-12 mt-3">
                      <h6 className="card-text-Color">Permissions</h6>
                      <div className="checkbox-group">
                        {permissionArray.map((permission, index) => (
                          <div key={index} className="form-check">
                            <input
                              type="checkbox"
                              id={`permission-${index}`}
                              className="form-check-input"
                              value={permission.value}
                              onChange={(e) => {
                                const selectedPermissions =
                                  formik.values.permissions || [];
                                if (e.target.checked) {
                                  formik.setFieldValue("permissions", [
                                    ...selectedPermissions,
                                    permission.value,
                                  ]);
                                } else {
                                  formik.setFieldValue(
                                    "permissions",
                                    selectedPermissions.filter(
                                      (perm) => perm !== permission.value
                                    )
                                  );
                                }
                              }}
                              checked={formik.values.permissions.includes(
                                permission.value
                              )}
                            />
                            <label
                              htmlFor={`permission-${index}`}
                              className="form-check-label card-text-Color"
                            >
                              {permission.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              }
            />
          }
        />

        {/* Broker Record */}
        {showBrokerModal && (
          <>
            {/* Dark overlay */}
            <div className="modal-backdrop fade show"></div>

            <div
              className="modal fade show"
              id="broker_record_modal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="brokerModalLabel"
              aria-hidden="true"
              style={{ display: "block" }}
            >
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content card-bg-color">
                  <div className="modal-header p-3">
                    <h5
                      className="modal-title card-text-Color"
                      id="brokerModalLabel"
                    >
                      Broker Group Record
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setShowBrokerModal(false);
                        setBrokerRecordData([]);
                      }}
                    />
                  </div>
                  <hr style={{ margin: "0" }} />

                  <div
                    className="modal-body p-3 card-bg-color"
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                  >
                    {brokerRecordData?.length > 0 ? (
                      brokerRecordData.map((item, index) => (
                        <div
                          key={index}
                          className="mb-4 p-3 border rounded card-bg-color"
                        >
                          <div className="row">
                            <div className="col-md-6 mb-2">
                              <strong className="card-text-Color">
                                Username:
                              </strong>{" "}
                              {item.Username}
                            </div>
                            <div className="col-md-6 mb-2">
                              <strong className="card-text-Color">Date:</strong>{" "}
                              {item.Date}
                            </div>
                            <div className="col-md-6 mb-2">
                              <strong className="card-text-Color">
                                Broker:
                              </strong>{" "}
                              {item.Broker}
                            </div>

                            <div className="col-md-6 mb-2">
                              <strong className="card-text-Color">
                                SubAdmin:
                              </strong>{" "}
                              {item.SubAdmin?.length
                                ? Array.isArray(item.SubAdmin)
                                  ? item.SubAdmin.join(", ")
                                  : item.SubAdmin
                                : "Admin"}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No records found.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Plan Assignment Modal */}
        <ReusableModal
          show={showPlanModal}
          onClose={() => {
            setShowPlanModal(false);
            setSelectedClientForPlan(null);
            setSelectedBroker("");
            planFormik.resetForm();
          }}
          title={`Assign Plan & Amount - ${selectedClientForPlan?.Username}`}
          size="xl"
          body={
            <form onSubmit={planFormik.handleSubmit}>
              {/* Current Client Info */}
              <div className="row mb-4">
                <div className="col-12">
                  <h6 className="text-primary mb-2">Current Information</h6>
                  <div className="card p-3 bg-light">
                    <div className="row">
                      <div className="col-md-4 mb-2">
                        <p className="mb-0">
                          <strong>Username:</strong>{" "}
                          {selectedClientForPlan?.Username || "-"}
                        </p>
                      </div>
                      <div className="col-md-4 mb-2">
                        <p className="mb-0">
                          <strong>Current Amount:</strong> ₹
                          {selectedClientForPlan?.Clientammount || "0"}
                        </p>
                      </div>
                      <div className="col-md-4 mb-2">
                        <p className="mb-0">
                          <strong>Current Plans:</strong>{" "}
                          {Array.isArray(selectedClientForPlan?.ActivePlan)
                            ? selectedClientForPlan.ActivePlan.join(", ")
                            : selectedClientForPlan?.ActivePlan || "None"}
                        </p>
                      </div>
                      {/* You can add more items here in col-md-6 if needed */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {/* Broker Asgin  */}
                <div className="col-lg-6 mb-3">
                  <label className="form-label card-text-Color">
                    <strong>Broker </strong>
                  </label>
                  <select
                    className="form-select"
                    name="Broker"
                    value={selectedBroker}
                    onChange={(e) => setSelectedBroker(e.target.value)}
                  >
                    {selectedClientForPlan?.BrokerName == "DEMO" && (
                      <option value="DEMO">DEMO</option>
                    )}
                    {brokers.map((broker) => (
                      <option key={broker.BrokerName} value={broker.BrokerName}>
                        {broker.BrokerName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Amount Input */}
                <div className="col-lg-6 mb-3">
                  <label className="form-label card-text-Color">
                    <strong>Amount (₹)</strong>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    value={planFormik.values.amount}
                    onChange={planFormik.handleChange}
                    onBlur={planFormik.handleBlur}
                    placeholder="Enter amount"
                    min="0"
                    step="0.01"
                  />
                  {planFormik.errors.amount && (
                    <div className="text-danger small mt-1">
                      {planFormik.errors.amount}
                    </div>
                  )}
                </div>
              </div>

              {/* Plan Selection */}
              <div className="mb-3">
                {/* Available Plans Section */}
                <div className="mb-3">
                  <h6 className="mb-3">
                    Available Plans (Select additional plans)
                  </h6>
                  <div className="row">
                    {allPlans?.live?.length > 0 ? (
                      allPlans.live.map((plan, index) => {
                        const isCurrentPlan =
                          selectedClientForPlan?.Planname &&
                          (Array.isArray(selectedClientForPlan.Planname)
                            ? selectedClientForPlan.Planname.includes(
                                plan.Planname
                              )
                            : selectedClientForPlan.Planname === plan.Planname);

                        if (isCurrentPlan) return null; // Skip current plans

                        return (
                          <div key={plan.id || index} className="col-md-3 mb-3">
                            
                              <div className="card p-3 border h-100">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`plan-${plan.id || index}`}
                                    value={plan.Planname}
                                    checked={planFormik.values.selectedPlans.includes(
                                      plan.Planname
                                    )}
                                    disabled={
                                      selectedClientForPlan?.Clientammount +
                                        planFormik.values.amount <
                                        plan.price ||
                                      selectedClientForPlan?.ActivePlan?.includes(
                                        plan.Planname
                                      )
                                    }
                                    onChange={(e) => {
                                      const newPlans = e.target.checked
                                        ? [
                                            // ...planFormik.values
                                            //   .selectedPlans,
                                            plan.Planname,
                                          ]
                                        : planFormik.values.selectedPlans.filter(
                                            (planName) =>
                                              planName !== plan.Planname
                                          );

                                      planFormik.setFieldValue(
                                        "selectedPlans",
                                        newPlans
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label w-100"
                                    htmlFor={`plan-${plan.id || index}`}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div>
                                        <h6 className="mb-1 text-dark">
                                          {plan.Planname}
                                        </h6>
                                      </div>
                                      <div className="text-end">
                                        {plan.price > 0 && (
                                          <div className="text-warning fw-bold">
                                            ₹{plan.price}
                                          </div>
                                        )}
                                        {!plan.price && (
                                          <div className="text-muted">
                                            Free Plan
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-12">
                        <div className="alert alert-warning text-center">
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          No live plans available at the moment
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {planFormik.errors.selectedPlans && (
                  <div className="text-danger small mt-1">
                    {planFormik.errors.selectedPlans}
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowPlanModal(false);
                    setSelectedClientForPlan(null);
                    planFormik.resetForm();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={planFormik.isSubmitting}
                >
                  {planFormik.isSubmitting
                    ? "Updating..."
                    : "Update Plan & Amount"}
                </button>
              </div>
            </form>
          }
        />
      </Content>
    </>
  );
};

export default Clientservice;
